import { motion } from "framer-motion";
import { Truck, Banknote, ShieldCheck, Lock } from "lucide-react";

const ITEMS = [
  { icon: Truck, title: "Free Express Shipping", sub: "Ships within 24 hours" },
  { icon: Banknote, title: "Cash on Delivery", sub: "Pay when it arrives" },
  { icon: ShieldCheck, title: "Secure COD Checkout", sub: "Pay only when it arrives" },
  { icon: Lock, title: "Secure Checkout", sub: "256-bit SSL encrypted" },
];

export default function ValueStrip() {
  return (
    <section className="border-b border-charcoal-900/10 bg-oat-50" data-testid="value-strip">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-x-6 gap-y-6 px-5 py-8 lg:grid-cols-4 lg:px-10">
        {ITEMS.map(({ icon: Icon, title, sub }, i) => (
          <motion.div
            key={title}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.5, delay: i * 0.06 }}
            className="flex items-center gap-3.5"
            data-testid={`value-item-${i}`}
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-sage-100">
              <Icon className="h-5 w-5 text-sage-700" strokeWidth={1.6} />
            </span>
            <span>
              <span className="block text-sm font-semibold text-charcoal-900">{title}</span>
              <span className="block text-xs text-charcoal-500">{sub}</span>
            </span>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
